import * as Auth from "./auth";
import * as User from "./user";
import * as Workgroup from "./workgroup";
import * as ACL from "./acl"
import * as Station from "./station";
import * as StationPhoto from "./stationPhoto";
import * as StationLink from "./stationLink";
import * as Group from "./group"
import * as Geo from "./geo";
import * as Model1 from "./model1";
import * as Model23 from "./model23";
import * as Registry from "./registry";
import * as MicroZone from "./microzone";
import * as ImportTask from "./importTask";
import * as ExportTask from "./exportTask";
import * as Timeseries from "./timeseries";
import * as UserSettings from "./userSettings";
import * as Incidents from "./incidents";
import * as Settings from "./settings";
import * as IncidentAttachment from "./IncidentAttachments";
import * as Territory from "./territory";
import * as Public from "./public";

import axios from "axios";

axios.defaults.headers.common['Content-Type'] = 'application/json';

export {
    Auth, User, Workgroup, ACL, Station, StationPhoto, StationLink, Group, Geo, Model1, Model23, Registry, MicroZone,
    ImportTask, Timeseries, UserSettings, Incidents, Settings, IncidentAttachment, Territory, Public, ExportTask
}